import React from 'react';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import { makeStyles } from '@mui/styles';
import { Grid, useMediaQuery, useTheme } from '@mui/material';
import KenButton from '../../../KenButton';
import { TABLET_BREAKPOINT } from '../../../../Constants/constant';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '16px',
    background: '#FFFFFF',
    boxShadow:
      '10px 0px 20px rgba(0, 0, 0, 0.04), 2px 0px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    paddingRight: '10vw',
    paddingLeft: '10vw',
    position: 'fixed',
    bottom: 0,
    width: '100%',
    minHeight: 76,
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      padding: '0px 16px',
      minHeight: '60px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  nextBtn: {
    display: 'flex',
    padding: '8px',
    gap: '8px',
    width: '140px',
    height: '48px',
    background: '#F6C445',
    borderRadius: '4px',
    fontStyle: 'normal',
    fontWeight: '500 !important',
    fontSize: '18px !important',
    lineHeight: '100% !important',
    textAlign: 'center',
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      width: 100,
    },
  },
}));

export default function KenStepperFooter({ onNext, applicationStatus = '' }) {
  const classes = useStyles();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(
    theme.breakpoints.down(TABLET_BREAKPOINT)
  );

  return (
    <div
      className={classes.root}
      style={{
        display:
          applicationStatus === 'Application form Incomplete' ||
          applicationStatus === ''
            ? ''
            : 'none',
      }}
    >
      <Grid container justifyContent="flex-end">
        <KenButton
          buttonClass={classes.nextBtn}
          type="submit"
          form="form-step0"
          variant="contained"
          onClick={onNext}
          disabled={applicationStatus === 'Application form Submitted'}
          endIcon={isMobileScreen ? null : <ArrowForwardOutlinedIcon />}
        >
          Submit
        </KenButton>
      </Grid>
    </div>
  );
}
